import React from "react"
import { Field } from "react-final-form"

import { Grid } from "@mui/material"
import { map } from "ramda"

import { FilterGroup } from "./layout"
import { Selector } from "../../../molecules"

export const SelectorsFilter = ({ items }) => {
  return (
    <FilterGroup xs={12}>
      <Grid container justifyContent="start" spacing={1}>
        {map(
          ({ label, name, options }) => (
            <Grid item xs={6} key={`si${name}`}>
              <Field name={name}>
                {({ input }) => <Selector {...input} options={options} label={label} />}
              </Field>
            </Grid>
          ),
          items,
        )}
      </Grid>
    </FilterGroup>
  )
}
